module.exports = __webpack_public_path__ + "img/blik.6824bdd4.svg";